import React from 'react';

interface LoginFeaturesProps {
  id?: string;
  className?: string;
}

const LoginFeatures: React.FC<LoginFeaturesProps> = ({ id, className }) => {
  return (
    <section id={id} className={`${className ?? ""} bg-gray-200 py-16`}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Elegí el plan que mejor se adapta a tu obra</h2>
        <p className="text-lg text-gray-600 mb-8">Configurá tu plan a medida y arrancá hoy mismo.</p>
        <a
          href="https://editor.lisual.com/pay/"
          className="inline-block bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-full transition-colors text-lg"
        >
          Configura tu plan
        </a>
      </div>
    </section>
  );
};

export default LoginFeatures;
